export class ChangeTicketEvent {
  constructor(public seatId: string, public ticketId: string) {
  }
}
